import {
    OUT_OF_STOCK_START,
    OUT_OF_STOCK_SUCCESS,
    OUT_OF_STOCK_ERROR,
  } from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
};
  
export default function outOfStockReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case OUT_OF_STOCK_START:
        return {
          ...state,
          loading: true,
        };
      case OUT_OF_STOCK_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case OUT_OF_STOCK_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  